exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3u3GRcO8NSbdqx7EbDXQ2S{color:\"[theme:neutralSecondary, default:#666666]\";font-size:24px}", ""]);
// Exports
exports.locals = {
	"icon": "_3u3GRcO8NSbdqx7EbDXQ2S"
};